{
  "longPressMessage": "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
}
